import { Controller } from "@hotwired/stimulus"
import { Tooltip } from "bootstrap"

export default class extends Controller {
  connect() {
    this.hideWhenClickingElsewhere = this.hideWhenClickingElsewhere.bind(this)
    this.instance = Tooltip.getOrCreateInstance(this.element, {
      trigger: "click",
      container: "body"
    })
    document.addEventListener("pointerdown", this.hideWhenClickingElsewhere)
  }

  disconnect() {
    document.removeEventListener("pointerdown", this.hideWhenClickingElsewhere)
    this.instance?.dispose()
  }

  hideWhenClickingElsewhere(event) {
    if (!this.element.contains(event.target)) this.instance.hide()
  }
}
